import  { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import api from "../../services/axios";
import { useAuth } from "../../context/AuthContext";

export default function PieChart() {
  const [chartData, setChartData] = useState([]);
  const { authUser } = useAuth();

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        const [ticketsRes, agentsRes] = await Promise.all([
          api.post("/getAllTickets", {}),
          // api.post("/getAllTickets", {
          //   isAdmin: authUser?.isAdmin,
          //   Code: authUser?.Code,
          // }),
          api.post("/list_agent" , {}),
        ]);

        const tickets = ticketsRes.data?.data || [];
        const agents = agentsRes.data?.data || [];

        const groupedTickets = groupTicketsByUser(tickets);
        const ticketCounts = countTicketsPerUser(groupedTickets);
        const formattedData = formatPieData(ticketCounts, agents);

        setChartData(formattedData);
      } catch (error) {
        console.error("Error fetching chart data:", error);
      }
    };

    fetchChartData();
  }, [authUser]);

  const groupTicketsByUser = (tickets) => {
    return tickets.reduce((acc, ticket) => {
      const userCode = ticket.User ?? "Unknown";
      const ticketId = ticket.Ticket_No ?? ticket.Call_Sr_No;

      if (ticketId) {
        if (!acc[userCode]) acc[userCode] = new Set();
        acc[userCode].add(ticketId);
      }

      return acc;
    }, {});
  };

  const countTicketsPerUser = (groupedTickets) => {
    return Object.entries(groupedTickets).reduce((acc, [userCode, ticketSet]) => {
      acc[userCode] = ticketSet.size;
      return acc;
    }, {});
  };

  const formatPieData = (ticketCounts, agents) => {
    return Object.entries(ticketCounts).map(([userCode, count]) => {
      const agent = agents.find((a) => String(a.Code) === userCode);
      const name = agent?.Agent_Name || `User ${userCode}`;
      return { name, y: count };
    });
  };

const chartOptions = {
  chart: {
    type: "pie",
    backgroundColor: "transparent",
  },
  title: {
    text:undefined,
    align: "center",
    verticalAlign: "middle",
    style: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "#333",
    },
  },
  tooltip: {
    pointFormat: "<b>{point.name}</b>: {point.y} tickets ({point.percentage:.1f}%)",
  },
  plotOptions: {
    pie: {
      innerSize: "60%",
      allowPointSelect: true,
      cursor: "pointer",
      borderWidth: 4, 
      borderColor: "#ffffff", // White space
      dataLabels: {
        enabled: true,
        format: "{point.name}", // Show user names
        style: {
          fontWeight: "bold",
          fontSize: "13px",
          color: "#000",
        },
      },
    },
  },
  colors: ["#5B8FF9", "#61DDAA", "#65789B", "#F6BD16", "#7262FD", "#78D3F8"],
  series: [
    {
      name: "Tickets",
      colorByPoint: true,
      data: chartData,
    },
  ],
  exporting: {
    enabled: false,
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 500,
        },
        chartOptions: {
          chart: {
            height: 300,
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: false,
              },
            },
          },
        },
      },
    ],
  },
};


  return (
     <div className="assisvia pie-chart">
       <h1>
          <strong>User Ticket History</strong>
        </h1>

      <div className="assisvia-header d-flex justify-content-between">
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />    
    </div>
    </div>
  );
}
